<template>
  <div 
    v-if="whitelabelConfig.config.footerText && whitelabelConfig.config.footerText.trim()"
    class="whitelabel-footer text-center py-lg px-md"
  >
    <ion-text color="medium" class="text-xs">
      {{ whitelabelConfig.config.footerText }}
    </ion-text>
  </div>
</template>

<script setup lang="ts">
import { IonText } from '@ionic/vue'
import { useWhitelabelConfig } from '../composables/useWhitelabelConfig'

// Whitelabel footer text display - Subtask 7.3
const whitelabelConfig = useWhitelabelConfig()
</script>

<style scoped>
.whitelabel-footer {
  border-top: 1px solid var(--ion-color-light);
  margin-top: var(--ion-spacing-lg);
}
</style>